export default __webpack_public_path__ + "static/media/bj1.0b41f464.png";